var _path, _path2, _path3, _rect, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11084 2.87948C5.11084 2.39376 5.5046 2 5.99032 2H15.7525L21.1173 7.7166V20.9967C21.1173 21.4824 20.7236 21.8762 20.2379 21.8762H5.99032C5.5046 21.8762 5.11084 21.4824 5.11084 20.9967V2.87948Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1172 7.71655V12.9934L15.8908 7.71654L21.1172 7.71655Z",
    fill: "#CAD1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7524 7.7166V2L21.1173 7.7166H15.7524Z",
    fill: "#FF6B00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.11084,
    y: 18.3582,
    width: 11.2573,
    height: 1.93485,
    fill: "#CAD1D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.8501,
    width: 13.3681,
    height: 7.21171,
    rx: 0.351791,
    fill: "#FF6B00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3995 17V13.3636H6.69567C6.97857 13.3636 7.21295 13.4151 7.39879 13.5181C7.58464 13.6211 7.72372 13.762 7.81605 13.9407C7.90838 14.1183 7.95455 14.3183 7.95455 14.5408C7.95455 14.7646 7.90779 14.9658 7.81428 15.1445C7.72195 15.3221 7.58227 15.4629 7.39524 15.5671C7.2094 15.6701 6.97562 15.7216 6.69389 15.7216H5.80256V15.2564H6.64418C6.82292 15.2564 6.96792 15.2256 7.07919 15.1641C7.19046 15.1013 7.27214 15.0161 7.32422 14.9084C7.3763 14.8007 7.40234 14.6781 7.40234 14.5408C7.40234 14.4035 7.3763 14.2816 7.32422 14.1751C7.27214 14.0685 7.18987 13.9851 7.07741 13.9247C6.96615 13.8643 6.81937 13.8342 6.63707 13.8342H5.94815V17H5.3995ZM8.59775 17V13.3636H9.89391C10.1768 13.3636 10.4112 13.4151 10.597 13.5181C10.7829 13.6211 10.922 13.762 11.0143 13.9407C11.1066 14.1183 11.1528 14.3183 11.1528 14.5408C11.1528 14.7646 11.106 14.9658 11.0125 15.1445C10.9202 15.3221 10.7805 15.4629 10.5935 15.5671C10.4076 15.6701 10.1739 15.7216 9.89213 15.7216H9.0008V15.2564H9.84242C10.0212 15.2564 10.1662 15.2256 10.2774 15.1641C10.3887 15.1013 10.4704 15.0161 10.5225 14.9084C10.5745 14.8007 10.6006 14.6781 10.6006 14.5408C10.6006 14.4035 10.5745 14.2816 10.5225 14.1751C10.4704 14.0685 10.3881 13.9851 10.2757 13.9247C10.1644 13.8643 10.0176 13.8342 9.83532 13.8342H9.1464V17H8.59775ZM11.6167 13.8359V13.3636H14.4309V13.8359H13.2963V17H12.7495V13.8359H11.6167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.9c5e9c0fbb0cbd95df63af4d3d0fe425.svg";
export { ForwardRef as ReactComponent };